import cloneDeep from 'lodash/cloneDeep'

const onRequest = ({ options }) => {
  const config = useRuntimeConfig();

  if (!options.baseURL) {
    options.baseURL = config.public.apiURL;
  }
  options.headers = {
    "x-csrf-token": generateRandomeKey(36),
  };
};

const onRequestError = ({ error }) => {
  console.error("request error", error);
  return Promise.reject(error);
};

const onResponse = ({}) => {};

const onResponseError = async ({ request, options, response, error }) => {
  const code = response.status;
  if (code === 403) {
    throw showError({ statusCode: 403 });
  }
  const url = response.url;
  const baseStore = useBaseStore();
  const localePath = useLocalePath();
  const authStore = useAuthStore();
  const { $notify } = useNuxtApp();
  const { t } = useNuxtApp().$i18n

  if (
    process.client &&
    response &&
    [401, 400].includes(code) &&
    !url.includes("refresh") &&
    !url.includes("logout") &&
    !url.includes("cs")
  ) {
    const { $auth0JS } = useNuxtApp();
    const config = useRuntimeConfig();
    const parseResponse =
      options.responseType === "blob"
        ? undefined
        : (text) => {
            try {
              return JSON.parse(text);
            } catch (e) {
              return text;
            }
          };
    let refreshRes = null;
    if (!baseStore.adminMode) {
      const resultCheckAuth0 = await $auth0JS.checkSession();
      if (resultCheckAuth0) {
        try {
          refreshRes = await $fetch.raw(config.public.apiURL + "/user/cs", {
            method: "POST",
            body: { id_token: $auth0JS.id_token },
            parseResponse,
          });
        } catch (err) {
          if (!baseStore.adminMode) {
            $auth0JS.logout();
          } else {
              if (!url.includes("login")) {
                $notify(
                  setNotificationConfig({
                    text: t('common.10400'),
                    type: "warn",
                  })
              );
            }
            authStore.$patch({ user: {} });
            baseStore.$patch({
              isAuthenticated: false,
            });
            window.location.href = localePath({ name: "index" })
          }
        }
      } else {
        window.location.href = localePath({ name: "index" })
      }
    } else {
      try {
        refreshRes = await $fetch.raw(config.public.apiURL + "/admin/refresh", {
          method: "POST",
          body: { rememberMe: baseStore.rememberMe },
          parseResponse,
          headers: {
            "x-csrf-token": generateRandomeKey(36),
          },
        });
      } catch (err) {
        console.error("Refresh admin token failed:", err);
        refreshRes = null;
      }
    }
    if (refreshRes && refreshRes.status) {
      authStore.$patch({ user: $auth0JS.user });
      baseStore.$patch({ isAuthenticated: true });
      const retryRequest = cloneDeep(request);
      const retryOptions = cloneDeep(options);
      return await $fetch(retryRequest, retryOptions);
    }
  } else if (
    process.client &&
    [401, 400].includes(code) &&
    url.includes("refresh")
  ) {
    authStore.$patch({ user: {} });
    baseStore.$patch({
      isAuthenticated: false,
    });
    window.location.href = localePath({ name: "index" })
  } else if (
    process.client &&
    [401, 400].includes(code) &&
    url.includes("cs")
  ) {
    $auth0JS.logout($auth0JS.user.lang.code || "ja");
  } else {
    console.error(error);
  }
  throw response;
};

const baseOptions = {
  // parseResponse: JSON.parse,
  onRequest,
  onRequestError,
  onResponse,
  onResponseError,
};

export async function useApi(path, options = {}) {
  const config = useRuntimeConfig();
  const parseResponse =
    options.responseType === "blob"
      ? undefined
      : (text) => {
          try {
            return JSON.parse(text);
          } catch (e) {
            return text;
          }
        };
  const response = await $fetch.raw(config.public.apiURL + path, {
    ...baseOptions,
    ...options,
    parseResponse,
  });

  const { _data, headers } = response;

  return {
    data: _data,
    headers,
  };
}

export function useGet(path, options = {}) {
  return useApi(path, { ...options, method: "GET" });
}

export function usePost(path, data, options = {}) {
  return useApi(path, { ...options, body: data, method: "POST" });
}

export function usePut(path, data, options = {}) {
  return useApi(path, { ...options, body: data, method: "PUT" });
}

export function useDelete(path, options = {}) {
  return useApi(path, { ...options, method: "DELETE" });
}
